import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";
import { useState } from "react";

import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  Empty,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
  LargeA,
} from "./styles";
import { CustomNavLinkSmall, Span } from "../Header/styles";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: { t: TFunction }) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" fetchPriority="high" />
      </a>
    );
  };

  const [visible, setVisibility] = useState(false);

  const scrollTo = (id: string) => {
      const element = document.getElementById(id) as HTMLDivElement;
      element.scrollIntoView({
        behavior: "smooth",
      });
      setVisibility(false);
    };

  return (
    <>
      <FooterSection>
        <Container border={true}>
          <Empty />
          <Empty />
          <Row justify="space-between">
            <Col lg={4} md={4} sm={12} xs={12}>
              <Language>{t("Contact")}</Language>
              <LargeA href="mailto:ALDN-Digital@outlook.com">Email Us</LargeA>
              <LargeA
                href="https://wa.me/27821234567?text=Hi%20ALDN%20Digital%2C%20I%20want%20to%20know%20more%20about%20your%20services."
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp Us
              </LargeA>
            </Col>
            <Col lg={4} md={4} sm={12} xs={12}>
              <Language>{t("Locations")}</Language>
              <Large to="/">Pretoria, South Africa</Large>
              <Large to="/">Cape Town, South Africa</Large>
            </Col>
            <Col lg={4} md={4} sm={12} xs={12}>
              <Language>{t("Connect With Us")}</Language>
              <LargeA href="https://www.linkedin.com/" 
                target="_blank"
                rel="noopener noreferrer"
              >
                <SvgIcon src="linkedin.svg" width="20px" height="20px" fetchPriority="high" />
              </LargeA>
            </Col>
          </Row>
        </Container>
      </FooterSection>
    </>
  );
};

export default withTranslation()(Footer);
